import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import './PriceCard.css';
import Paypal from './Paypal';
export default function PopupModal(props) {
	const [checkout, setCheckout] = useState(false);
	console.log('Modal ' + props.title + ' ' + props.price);

	return (
		<Modal
			{...props}
			size="lg"
			aria-labelledby="contained-modal-title-vcenter"
			centered
		>
			<Modal.Header closeButton>
				<Modal.Title id="contained-modal-title-vcenter">
					Confim Checkout
				</Modal.Title>
			</Modal.Header>
			<Modal.Body className="pricing-modal ">
				<h4>Package Name - {props.title}</h4>
				<br />
				<div className="price">
					<sup>$</sup>
					{props.price}
				</div>
				{checkout ? (
					<Paypal title={props.title} price={props.price} />
				) : (
					<button className="order-btn" onClick={() => setCheckout(true)}>
						Proceed Checkout
					</button>
				)}
			</Modal.Body>
		</Modal>
	);
}
